<template>
  <div>
    <img
      src="/static/img/download/Download.jpg"
      class="backgroundImg"
    >
    <div
      class="not-browser-tip"
      v-if="isWeChatApplet"
    >
      <img src="data:image/png;base64,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" />
      <div class="detail">
        <div>isWeChatApplet:{{$nw.UA.isWeChatApplet}}</div>
        <div>isWeChatApplet:{{isWeChatApplet}}</div>
        1. 长按上方二维码保存至本地。<br />
        2. 用扫一扫扫描相册中已下载的二维码，用手机浏览器打开。<br />
        3. 下载安装<br />
      </div>
    </div>
    <div
      class="not-browser-tip"
      v-else-if="$nw.UA.isWeChat"
    >
      <span style="font-size:25px">点击右上角三个点，选择在浏览器打开</span>
    </div>
    <div v-else>
      <van-button
        v-if="$nw.UA.isAndroid"
        class="button"
        type="primary"
        size="normal"
        url="http://fir.lvjingservice.com/8gzr"
      ><img
          class="icon"
          src="/static/img/download/android.png"
        >ANDROID下载</van-button>
      <van-button
        v-else
        class="button"
        type="primary"
        size="normal"
        url="https://apps.apple.com/cn/app/id1474938537"
      ><img
          class="icon"
          src="/static/img/download/ios.png"
        >IOS下载</van-button>
    </div>
    <p class="beian-footer">© 2026 绿晶小程序 |
      <a
        href="https://beian.miit.gov.cn"
        target="_blank"
      >浙ICP备18033581号</a>
    </p>
    <!--<action-bar title="下载app"></action-bar>-->
    <!--<img class="img" v-if="$nw.UA.isAndroid"-->
    <!--src="https://publicapp.oss-cn-hangzhou.aliyuncs.com/release/androidDownloadCode.png">-->
    <!--<img class="img" v-else src="https://publicapp.oss-cn-hangzhou.aliyuncs.com/release/iosDownloadCode.png">-->
    <!--<div class="title wrap">-->
    <!--下载方式一：二维码下载。<br/>-->

    <!--</div>-->
    <!--<div class="title wrap">-->
    <!--其他下载方式：链接下载。<span></span><br/>-->
    <!--<div class="detail">-->
    <!--<div>-->
    <!--<span class="wrap">{{downloadUrl}}</span>-->
    <!--<span class="copy" @click="copyUrl">&nbsp;&nbsp;&nbsp;&nbsp;(点击复制下载链接)</span>-->
    <!--</div>-->
    <!--<div class="introduce">-->
    <!--1. <span >复制上方下载链接<br/></span>-->
    <!--2. <span >在浏览器中粘贴并打开此链接<br/></span>-->
    <!--3. <span >下载安装<br/></span>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script>
  import UA from "@/nvwa/nvwaEnvironment";


  export default {
    name: "downloadApp",
    components: {},

    data() {
      return {
        downloadUrl: "",
        isWeChatApplet: false,
      }
    },
    created() {
      if (this.$nw.UA.isAndroid) {
        this.downloadUrl = "http://fir.lvjingservice.com/8gzr"
      } else {
        this.downloadUrl = "https://apps.apple.com/cn/app/id1474938537"
      }
      this.getIsWeChatApplet().then(data => {
        if (data) {
          this.$router.replace('/weChatAppletDownload')
        }
      })
    },
    methods: {
      getIsWeChatApplet() {
        // 是否为微信小程序
        const ua = window.navigator.userAgent.toLowerCase();
        return new Promise((resolve) => {
          if (ua.indexOf('micromessenger') == -1) {//不在微信或者小程序中
            resolve(false);
          } else {
            wx.miniProgram.getEnv((res) => {
              if (res.miniprogram) {//在小程序中
                resolve(true);
              } else {//在微信中
                resolve(false);
              }
            });
          }
        });
      }
      // copyUrl() {
      //     this.$copyText(this.downloadUrl).then(e => {
      //         this.$toast('复制成功')
      //     }, function (e) {
      //         this.$toast('复制失败，请重试。或直接复制文字')
      //     })
      // }
    }
  }
</script>

<style scoped>
.beian-footer {
  margin: 0;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  padding: 8px 0;
  font-size: 12px;
  color: #666;
  background-color: #fff;
  border-top: 1px solid #eee;
  z-index: 999;
}
.backgroundImg {
  position: absolute;
  width: 375px;
  height: auto;
}
.tip {
  position: relative;
  color: white;
  top: 375px;
  left: 70px;
}

.not-browser-tip {
  position: relative;
  color: white;
  top: 325px;
  margin-left: 35px;
  width: 305px;
  word-break: break-word;
}
.button {
  position: relative;
  background-color: #04cbb4;
  border-color: #ffffff;
  top: 375px;
  left: 100px;
  width: 183px;
  height: 40px;
}
.icon {
  position: relative;
  padding-right: 3px;
  top: 5px;
  width: 18px;
  height: 21px;
}
.title {
  width: 300px;
  margin-left: 30px;
  margin-top: 20px;
  line-height: 30px;
  color: #666;
}

.detail {
  width: 300px;
  padding-left: 20px;
  font-size: 13px;
  line-height: 25px;
  color: #999;
}

.img {
  width: 375px;
  height: auto;
}

.copy {
  color: white;
}
</style>
